/**
 * Centralized API configuration
 * Uses REACT_APP_API_URL environment variable with fallback to production API
 */

// Production API URL (custom domain)
const PRODUCTION_API_URL = 'https://api.omnipass.rs/api/v1';

// Local development URL
const LOCAL_BACKEND_URL = 'http://localhost:8000/api/v1';

// Use environment variable if available, otherwise check if running on production domain
const isProduction = window.location.hostname.includes('omnipass.rs');

export const API_BASE_URL = process.env.REACT_APP_API_URL || (isProduction ? PRODUCTION_API_URL : LOCAL_BACKEND_URL);

// Base URL without /api/v1 for endpoints that already include it
export const API_HOST = API_BASE_URL.replace('/api/v1', '');
